<template>
    <div class="container step step1">
        <div class="card-container">
            <a href="#" class="question" @click.prevent="pageChange = !pageChange">
                <img src="../../assets/step2/page2_question.png" v-if="pageChange == false" alt="">
                <img src="../../assets/step2/page2_question_change.png" v-if="pageChange" alt="">
            </a>
            <img src="../../assets/step2/page2_card.png" class="card" alt="">
            <img src="../../assets/step2/page2_people.png" class="people" alt="">
        </div><!-- card container end sub -->
        <img src="../../assets/step2/page2_bg.png" class="bg" alt="">
        <template>
            <router-link to="/step1-2" class="btn-prev el-icon-arrow-left"></router-link>
            <router-link to="/step2-1" class="btn-next el-icon-arrow-right"></router-link>
        </template>
    </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      pageChange: false
    }
  }
}
</script>

<style scoped>
    .step .people {
        width:350px;position:relative;
        left:-50px;
    }
    .step .question {
        width:290px;
    }
    .step .card {top:0;width:278px;}
    .btn-prev {
        color:#f39800;
    }
    .btn-next {
        background:#f39800;color:white;
    }
</style>



// WEBPACK FOOTER //
// src/components/step2/index.vue